var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("AirExport.BatchModificationOfReportStatus"),
        width: _vm.$selectByLang("253px", "328px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("75px", "165px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("AirExport.CustomsClearanceStatus") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: { no: "1" },
                  model: {
                    value: _vm.declareCustomsState,
                    callback: function($$v) {
                      _vm.declareCustomsState = $$v
                    },
                    expression: "declareCustomsState"
                  }
                },
                _vm._l(_vm.DECLARE_CUSTOMS_STATE, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: _vm.$getLangColumn(item), value: item.code }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "2" },
              on: { click: _vm.okClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "3" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }